"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enVKVStrategy = void 0;
const transform_types_1 = require("../../../types/transform.types");
const formatConsumptionText_1 = require("../../formatConsumptionText");
const formatEecText_1 = require("../../formatEecText");
const textResources_1 = require("../../textResources");
const enVKVStrategy = ({ locale, i18nlanguage }, output) => {
    const resources = new textResources_1.I18nText(locale, i18nlanguage);
    const result = Object.assign({}, output);
    result.formattedCo2Class = (0, formatEecText_1.formatEecText)(resources, output.vehicleType, output.eec);
    if (output.vehicleType === transform_types_1.VehicleTypeEnum.OVCHEV) {
        result.formattedDischargedCo2Class = (0, formatEecText_1.formatEecText)(resources, output.vehicleType, output.eecSustaining, true);
        result.formattedDischargedConsumption = (0, formatConsumptionText_1.formatDischargedConsumptionText)(resources, output.vehicleType, output.fuels);
    }
    return result;
};
exports.enVKVStrategy = enVKVStrategy;
